module.exports = "<p>\n  eliminar works!\n</p>\n"